import { useQuery } from '@tanstack/react-query'
import { getBeginnerBonusList } from '../../../../api/agencyAdmin/bonus';

function useGetBonus() {

    const BeginnerQuery = useQuery({
        queryFn: () => getBeginnerBonusList({

        }),
        queryKey: ["beginners_list"],

        //placeholderData: (previousData, previousQuery) => previousData, // identity function with the same behaviour as `keepPreviousData`,


    });


    return {
        BeginnerQuery
    }
}

export default useGetBonus;
